const ScreenSaver =()=> {
return <img src="https://a.storyblok.com/f/305344/3482x5117/b87613681a/copyright-george-nebieridze.JPG" alt="Banu with PINK background" />
}

export default ScreenSaver
